import React, { useState } from "react";
import TestCard from "./TestCard";
import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "& .MuiTypography-h3": {
      color: "#252525",
      fontSize: "1.625rem",
      fontFamily: "Playfair Display",
      fontWeight: "700",
      textTransform: "capitalize",
      [theme.breakpoints.down("xs")]: {
        textAlign: "center",
        fontSize: "1.2rem",
      },
    },
  },
  line: {
    background: "linear-gradient(90deg, #FF8008 0%, #FFC837 100%)",
    height: 5,
    width: 180,
    margin: "1rem 0rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  heading: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },
  loadMore: {
    marginBottom: "2rem",
  },
}));

const TestSection = ({ data, previousyearpaperDetail }) => {
  const classes = useStyles();
  const [visibleCount, setVisibleCount] = useState(8); // Show only 2 initially

  // Combine both arrays and remove duplicates
  const previousyearpaperDetailNew = [
    ...new Set([
      ...previousyearpaperDetail.previous_year_papers,
      ...previousyearpaperDetail.pdf_papers,
    ]),
  ];

  // Filter tests for the selected year
  const filteredTests = previousyearpaperDetailNew.filter(
    (test) => test.year === data
  );

  return (
    <Container className={classes.container} maxWidth="lg" sx={{ py: 4 }}>
      <div>
        <Typography variant="h3" className={classes.heading}>
          {previousyearpaperDetail.exam.exam_name} {data} Question Paper (Total
          Tests: {filteredTests.length})
        </Typography>

        <div className={classes.line}></div>
      </div>
   
        <Grid container spacing={1}>
          {filteredTests.slice(0, visibleCount).map((test) => (
            <Grid item xs={12} sm={6} md={6} key={test.id}>
              <TestCard test={test} />
            </Grid>
          ))}
        </Grid>


      {/* Load More Button */}
      {filteredTests.length >= visibleCount ? (
        <Box textAlign="center" mt={3} className={classes.loadMore}>
          <Button
            variant="outlined"
            onClick={() =>
              filteredTests.length === visibleCount
                ? setVisibleCount(8)
                : setVisibleCount(filteredTests.length)
            } // Show all items
          >
            {filteredTests.length === visibleCount ? "Hide" : "Load More"}
          </Button>
        </Box>
      ) : (
        <Box textAlign="center" mt={3} className={classes.loadMore}></Box>
      )}
    </Container>
  );
};

export default TestSection;
